import {inject}             from '@angular/core';
import {DataFactoryService} from '../../../logr-services/data/data-factory.service';
import {MenuBaseService}    from './menu-base.service';

export abstract class MenuPanelBase {

	svcMenuBase = inject(MenuBaseService)
	svcDataFactory = inject(DataFactoryService);
}
